import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/feature.svg';
import TitlePage from '~/components/atoms/Editorial/TitlePage.vue';
import SubtitlePage from '~/components/atoms/Editorial/SubtitlePage.vue';
export default {
  name: 'SimpleHeaderNoBackground',
  components: {
    TitlePage: TitlePage,
    SubtitlePage: SubtitlePage
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    title: function title() {
      return this.payload.primary.title[0] || {};
    },
    subtitle: function subtitle() {
      return this.payload.primary.subtitle[0] || {};
    },
    colorSvg: function colorSvg() {
      return this.payload.primary.color_svg;
    }
  }
};